import ColorStyles from '@Resources/styles/colors.scss';
import _isNil from 'lodash/isNil';
import React from 'react';
import Styles from './EntityDataRow.scss';

export interface IEntityDataRowProps {
    keyName: string;
    value: any;
    backgroundSuccess?: boolean;
}

export const EntityDataRow = (props: IEntityDataRowProps) => {
    const { keyName, value, backgroundSuccess } = props;

    return (
        <div
            className={Styles.baseAttributeRow}
            style={
                backgroundSuccess
                    ? { backgroundColor: ColorStyles.ikeSecondaryDarkGreen }
                    : null
            }
        >
            <div className={Styles.attributeRowKey}>
                <span style={backgroundSuccess ? { color: '#FFFFFF' } : null}>
                    {keyName}
                </span>
            </div>
            <div className={Styles.attributeRowValue}>
                <span style={backgroundSuccess ? { color: '#FFFFFF' } : null}>
                    {value}
                </span>
            </div>
        </div>
    );
};
